import { type ITypeState } from "@interfaces/common/ITypeState";
import { Store } from "@ngxs/store";
import { CommonService } from "@services/common.service";
import { SetTypeState } from "@state/common/common.action";
import { map } from "rxjs";

import { inject } from "@angular/core";
import { type ResolveFn } from "@angular/router";

export const typeStatesResolver: ResolveFn<ITypeState[]> = () => {
  const commonService = inject(CommonService);
  const store = inject(Store);

  return commonService.getTypeStates().pipe(
    map(states => {
      store.dispatch(new SetTypeState(states.data));
      return states.data;
    })
  );
};
